import { AlertMessage } from './alertMessage.view';

export default AlertMessage;
